import React from 'react';

import { Icon } from '@chakra-ui/react';

export const LinkIcon = props => (
  <Icon viewBox="0 0 1815 852" color="inherit" h="full" w="full" {...props}>
    <g transform="translate(-1292 -811)">
      <g>
        <path
          d="M2678.34 1663 2355 1663 2355 1508.46 2678.34 1508.46C2828.04 1508.46 2949.4 1387.15 2949.4 1237.5 2949.4 1087.85 2828.04 966.54 2678.34 966.54L2355 966.54 2355 812 2678.34 812C2913.42 812 3104 1002.5 3104 1237.5 3104 1472.49 2913.42 1663 2678.34 1663Z"
          fill="currentColor"
          fillRule="evenodd"
          fillOpacity="1"
        />
        <path
          d="M1721.66 812 2045 812.001 2045 966.541 1721.66 966.54C1571.96 966.54 1450.6 1087.85 1450.6 1237.5 1450.6 1387.15 1571.96 1508.46 1721.66 1508.46L2045 1508.46 2045 1663 1721.66 1663C1486.58 1663 1296 1472.49 1296 1237.5 1296 1002.5 1486.58 812 1721.66 812L1721.66 886.778 1721.66 812Z"
          fill="currentColor"
          fillRule="evenodd"
          fillOpacity="1"
        />
        <path
          d="M1736 1160 2664 1160 2664 1315 1736 1315 1736 1160Z"
          fill="currentColor"
          fillRule="evenodd"
          fillOpacity="1"
        />
      </g>
    </g>
  </Icon>
);
